import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { Reveal } from '../components/Reveal';
import { Button } from '../components/Button';
import { ApproachSection } from '../components/ApproachSection';
import { ConfiguredForm } from '../components/ConfiguredForm';
import { employerFormConfig } from '../data/forms';
import { employerBriefItems, images } from '../data/content';
import { services } from '../data/services';
import { contactEmail } from '../data/navigation';
export function Employers() {
  return <>
      <PageHeader label="For Employers" title="Hire experienced talent with a focused search partner." intro="Whether you need a confidential leadership search or focused sourcing support for a specialist role, we work from a clear brief and engage relevant candidates on your behalf." image={{
      src: images.employers,
      alt: 'A senior executive reviewing documents by an office window'
    }} actions={<>
            <Button href="#enquiry" data-id="element-398" data-mp="3ekx4pq4ge9pz">Submit a Hiring Enquiry</Button>
            <Button to="/services" variant="outline" data-id="element-399" data-mp="3ejm0xqb0d1yv">
              View Services
            </Button>
          </>} data-id="element-397" data-mp="cqu6rvstejlz" />

      <section aria-labelledby="support-heading" className="bg-white py-20 lg:py-24" data-id="element-400" data-mp="35la0kwkcapt8">
        <div className="mx-auto grid max-w-7xl gap-10 px-6 lg:grid-cols-12 lg:gap-12 lg:px-10" data-id="element-401" data-mp="3ajlb79igl4ci">
          <Reveal className="lg:col-span-4" data-id="element-402" data-mp="2vv7ab44lrpyl">
            <span className="block h-px w-12 bg-gold" aria-hidden="true" data-id="element-403" data-mp="2vu5ny3i4zh1k" />
            <h2 id="support-heading" className="mt-6 font-serif text-4xl font-medium leading-[1.1] text-navy" data-id="element-404" data-mp="30lxcy9ln9epl">
              How we can support your hiring
            </h2>
          </Reveal>
          <ul className="grid gap-x-12 gap-y-8 sm:grid-cols-2 lg:col-span-8" data-id="element-405" data-mp="2qvcj0zgx0yd0">
            {services.map(({
            title,
            description
          }, i) => <li key={title} data-id="element-406" data-mp="2cwl4jby55aoc" data-mpi={i}>
                <Reveal delay={i * 0.04} className="border-t border-gold/40 pt-6" data-id="element-407" data-mp="2hv68nmgikei2">
                  <h3 className="font-serif text-2xl font-medium text-navy" data-id="element-408" data-mp="2hx8uduamvlgz">{title}</h3>
                  <p className="mt-2 leading-relaxed text-ink/70" data-id="element-409" data-mp="ng8wghsjgr39">{description}</p>
                </Reveal>
              </li>)}
          </ul>
        </div>
      </section>

      <div className="border-t border-ink/10" data-id="element-410" data-mp="enf9dy6uoneu">
        <ApproachSection data-id="element-411" data-mp="9njagdd0fm65" />
      </div>

      <section id="enquiry" className="scroll-mt-24 bg-mist py-24 lg:py-32" data-id="element-412" data-mp="9olx293av2g9">
        <div className="mx-auto grid max-w-7xl gap-14 px-6 lg:grid-cols-12 lg:gap-12 lg:px-10" data-id="element-413" data-mp="16eboz6kap65t">
          <Reveal className="lg:col-span-5" data-id="element-414" data-mp="12bousz05j95g">
            <span className="block h-px w-12 bg-gold" aria-hidden="true" data-id="element-415" data-mp="12czw8s64k4te" />
            <h2 className="mt-6 font-serif text-4xl font-medium leading-[1.1] text-navy sm:text-5xl" data-id="element-416" data-mp="xc2hyqo8jux6">
              Submit a hiring enquiry
            </h2>
            <p className="mt-6 max-w-md text-lg leading-relaxed text-ink/75" data-id="element-417" data-mp="3i3cpsovlurlm">
              Share a few details about the role. Everything is treated confidentially.
            </p>
            <div className="mt-10 max-w-md" data-id="element-418" data-mp="3d6cf20nt90o6">
              <p className="text-sm font-medium text-ink" data-id="element-419" data-mp="33147w8nro7zw">Helpful to include in your brief</p>
              <ul className="mt-3 divide-y divide-ink/10 border-y border-ink/10" data-id="element-420" data-mp="37ymie3hfmva0">
                {employerBriefItems.map(item => <li key={item} className="flex items-center gap-4 py-3.5 text-[15px] text-ink/75" data-id="element-421" data-mp="3cwxp45cfkpo0">
                    <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-gold" aria-hidden="true" data-id="element-422" data-mp="3hqjvjfs03xbd" />
                    {item}
                  </li>)}
              </ul>
            </div>
            <p className="mt-8 text-sm text-ink/70" data-id="element-423" data-mp="3qo2m0zoez3un">
              Prefer email?{' '}
              <a href={`mailto:${contactEmail}`} className="font-medium text-navy underline decoration-gold underline-offset-4" data-id="element-424" data-mp="3vpjkypnc8g8l">
                {contactEmail}
              </a>
            </p>
          </Reveal>
          <div className="lg:col-span-7" data-id="element-425" data-mp="21ctnjxxrgowg">
            <ConfiguredForm config={employerFormConfig} data-id="element-426" data-mp="269slkrkjpfzx" />
          </div>
        </div>
      </section>
    </>;
}